<template>
  <div class="step-config-form">
    <el-form label-width="150px">
      <el-form-item label="需要的进度">
        <el-input v-model="localConfig.progress" placeholder="请输入进度"></el-input>
      </el-form-item>
      <el-form-item label="阶段最大进度">
        <el-input v-model="localConfig.maxProgress" placeholder="请输入最大进度"></el-input>
      </el-form-item>
      <el-form-item v-if="showExpandLottery" label="膨胀阶段抽奖次数">
        <el-input-number v-model="localConfig.expandLotteryCount" :min="0"></el-input-number>
      </el-form-item>
      
      <el-divider>双倍奖励配置</el-divider>
      <el-form-item label="概率(万分率)">
        <el-input-number 
          v-model="localConfig.doubleRewardDetail.rate" 
          :min="0" 
          :max="10000" 
          placeholder="请输入概率"
          style="width: 100%"
        ></el-input-number>
        <span style="margin-left: 10px">例如：90% = 9000</span>
      </el-form-item>
      <el-form-item label="双倍奖励次数">
        <el-input-number v-model="localConfig.doubleRewardDetail.doubleRewardCount" :min="0"></el-input-number>
      </el-form-item>
      <el-form-item label="双倍奖励连续次数">
        <el-input-number v-model="localConfig.doubleRewardDetail.doubleRewardContinuous" :min="0"></el-input-number>
      </el-form-item>

      <el-divider>奖励详情列表</el-divider>
      <el-button type="primary" size="small" @click="addRewardDetail">添加奖励</el-button>
      <div v-for="(item, index) in localConfig.rewardDetailList" :key="index" style="margin-top: 15px; padding: 15px; border: 1px solid #ddd; border-radius: 4px">
        <el-form-item label="概率(万分率)">
          <el-input-number v-model="item.rate" :min="0" :max="10000"></el-input-number>
          <span style="margin-left: 10px">例如：90% = 9000</span>
        </el-form-item>
        <el-form-item label="奖励类型">
          <el-select v-model="item.rewardType">
            <el-option
              v-for="rewardType in rewardTypeList"
              :key="rewardType.value"
              :label="rewardType.label"
              :value="rewardType.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="低价值券产出">
          <el-input-number v-model="item.lowTicketDetail.minReward" :min="0" placeholder="最小"></el-input-number>
          <span style="margin: 0 10px">-</span>
          <el-input-number v-model="item.lowTicketDetail.maxReward" :min="0" placeholder="最大"></el-input-number>
        </el-form-item>
        <el-form-item label="中价值券产出">
          <el-input-number v-model="item.middleTicketDetail.minReward" :min="0" placeholder="最小"></el-input-number>
          <span style="margin: 0 10px">-</span>
          <el-input-number v-model="item.middleTicketDetail.maxReward" :min="0" placeholder="最大"></el-input-number>
        </el-form-item>
        <el-form-item label="高价值券产出">
          <el-input-number v-model="item.highTicketDetail.minReward" :min="0" placeholder="最小"></el-input-number>
          <span style="margin: 0 10px">-</span>
          <el-input-number v-model="item.highTicketDetail.maxReward" :min="0" placeholder="最大"></el-input-number>
        </el-form-item>
        <el-form-item label="膨胀阶段产出">
          <el-input-number v-model="item.expandDetail.minReward" :min="0" placeholder="最小"></el-input-number>
          <span style="margin: 0 10px">-</span>
          <el-input-number v-model="item.expandDetail.maxReward" :min="0" placeholder="最大"></el-input-number>
        </el-form-item>
        <el-button type="danger" size="small" @click="removeRewardDetail(index)">删除此奖励</el-button>
      </div>

      <el-divider>阶段保底配置</el-divider>
      <el-form-item label="成本">
        <el-input v-model="localConfig.baseLine.cost" placeholder="请输入成本"></el-input>
      </el-form-item>
      <el-form-item label="进度">
        <el-input v-model="localConfig.baseLine.progress" placeholder="请输入进度"></el-input>
      </el-form-item>
      <el-form-item label="最大补足">
        <el-input v-model="localConfig.baseLine.maxReward" placeholder="请输入最大补足"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getConstList } from '@/api/constRequest'

export default {
  name: 'StepConfigForm',
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    showExpandLottery: {
      type: Boolean,
      default: false,
    },
    rsList: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  data() {
    return {
      localConfig: {},
      isUpdating: false, // 标志位，防止循环更新
      rewardTypeList: [], // 奖励类型列表
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        // 防止循环更新：设置标志，防止触发 localConfig watch
        this.isUpdating = true
        const defaultData = this.getDefaultData()
        if (val && Object.keys(val).length > 0) {
          // 深度合并，确保所有嵌套对象都存在
          this.localConfig = {
            progress: val.progress !== undefined ? val.progress : defaultData.progress,
            maxProgress: val.maxProgress !== undefined ? val.maxProgress : defaultData.maxProgress,
            expandLotteryCount: val.expandLotteryCount !== undefined ? val.expandLotteryCount : defaultData.expandLotteryCount,
            doubleRewardDetail: {
              rate: val.doubleRewardDetail?.rate !== undefined ? (typeof val.doubleRewardDetail.rate === 'string' ? parseInt(val.doubleRewardDetail.rate) || 0 : val.doubleRewardDetail.rate) : defaultData.doubleRewardDetail.rate,
              doubleRewardCount: val.doubleRewardDetail?.doubleRewardCount !== undefined ? val.doubleRewardDetail.doubleRewardCount : defaultData.doubleRewardDetail.doubleRewardCount,
              doubleRewardContinuous: val.doubleRewardDetail?.doubleRewardContinuous !== undefined ? val.doubleRewardDetail.doubleRewardContinuous : defaultData.doubleRewardDetail.doubleRewardContinuous,
            },
            rewardDetailList: (val.rewardDetailList || []).map(item => ({
              rate: item.rate !== undefined ? item.rate : 0,
              rewardType: item.rewardType !== undefined ? item.rewardType : (item.type !== undefined ? item.type : 1),
              lowTicketDetail: item.lowTicketDetail || { minReward: 0, maxReward: 0 },
              middleTicketDetail: item.middleTicketDetail || { minReward: 0, maxReward: 0 },
              highTicketDetail: item.highTicketDetail || { minReward: 0, maxReward: 0 },
              expandDetail: item.expandDetail || { minReward: 0, maxReward: 0 },
            })),
            baseLine: {
              cost: val.baseLine?.cost !== undefined ? val.baseLine.cost : defaultData.baseLine.cost,
              progress: val.baseLine?.progress !== undefined ? val.baseLine.progress : defaultData.baseLine.progress,
              maxReward: val.baseLine?.maxReward !== undefined ? val.baseLine.maxReward : defaultData.baseLine.maxReward,
            },
          }
          this.$nextTick(() => {
            this.isUpdating = false
          })
        } else {
          this.isUpdating = true
          this.localConfig = defaultData
          this.$nextTick(() => {
            this.isUpdating = false
          })
        }
      },
    },
    localConfig: {
      handler(val) {
        // 如果正在更新（从 value watch 触发），则不触发 emit
        if (this.isUpdating) {
          return
        }
        // 使用 $nextTick 确保在下一个更新周期再 emit，避免数据更新冲突
        this.$nextTick(() => {
          // 使用深拷贝避免循环引用
          this.$emit('input', JSON.parse(JSON.stringify(this.localConfig)))
        })
      },
      deep: true, // 深度监听，确保嵌套对象的变化也能触发更新
    },
  },
  methods: {
    getDefaultData() {
      return {
        progress: '',
        maxProgress: '',
        expandLotteryCount: 0,
        doubleRewardDetail: {
          rate: 0,
          doubleRewardCount: 0,
          doubleRewardContinuous: 0,
        },
        rewardDetailList: [],
        baseLine: {
          cost: '',
          progress: '',
          maxReward: '',
        },
      }
    },
    addRewardDetail() {
      if (!this.localConfig.rewardDetailList) {
        this.$set(this.localConfig, 'rewardDetailList', [])
      }
      this.localConfig.rewardDetailList.push({
        rate: 0,
        rewardType: 1,
        lowTicketDetail: { minReward: 0, maxReward: 0 },
        middleTicketDetail: { minReward: 0, maxReward: 0 },
        highTicketDetail: { minReward: 0, maxReward: 0 },
        expandDetail: { minReward: 0, maxReward: 0 },
      })
    },
    removeRewardDetail(index) {
      this.localConfig.rewardDetailList.splice(index, 1)
    },
    // 加载奖励类型列表
    async loadRewardTypeList() {
      try {
        const res = await getConstList('inviteLotteryRewardType')
        if (res.code === 0 && res.data) {
          this.rewardTypeList = res.data.map(item => ({
            label: item.desc || item.name || `类型${item.value}`,
            value: item.value,
          }))
        }
      } catch (error) {
        console.error('加载奖励类型列表失败:', error)
        // 如果加载失败，使用空数组
        this.rewardTypeList = []
      }
    },
  },
  created() {
    this.loadRewardTypeList()
  },
}
</script>

<style scoped>
.step-config-form {
  padding: 20px;
}
</style>

